import v_icon from "../../../assets/images/v-3d-icon.png";

const VestelIcon = ({ className }) => {
  return <img src={v_icon} alt="Vestel V Logo" className={className} />;
};

export default VestelIcon;
